module.exports = __webpack_public_path__ + "img/sobre-o-pedale.b14ec425.jpg";